import {
    useState, useEffect, useRef
} from 'react';
import PropTypes from 'prop-types';
import Text from 'atoms/Text';
import Tooltip from 'organisms/Tooltip';

// Renders a single-line subtitle that truncates with an ellipsis, showing the
// styled Tooltip with the full text only when the text is actually clipped
// (scrollWidth > clientWidth). Shared by the Command Stack and HIST/FAVS tiles.
const TruncatedSubtitle = ({ text, className, fontWeight }) => {
    const ref = useRef(null);
    const [isTruncated, setIsTruncated] = useState(false);

    useEffect(() => {
        const el = ref.current?.querySelector('p');
        if (!el) return undefined;

        const measure = () => setIsTruncated(el.scrollWidth > el.clientWidth);
        measure();

        const observer = new ResizeObserver(measure);
        observer.observe(el);
        return () => observer.disconnect();
    }, [text]);

    return (
        <Tooltip
            content={text}
            position="top"
            parentClass="block w-full min-w-0"
            disabled={!isTruncated}
        >
            <span ref={ref} className="block w-full min-w-0">
                <Text
                    variant="caption"
                    className={`truncate block w-full min-w-0 ${className}`}
                    fontWeight={fontWeight}
                >
                    {text}
                </Text>
            </span>
        </Tooltip>
    );
};

TruncatedSubtitle.propTypes = {
    text: PropTypes.string,
    className: PropTypes.string,
    fontWeight: PropTypes.string
};

TruncatedSubtitle.defaultProps = {
    text: '',
    className: 'text-gray-200 my-2',
    fontWeight: 'font-semibold'
};

export default TruncatedSubtitle;
